import { Redirect } from 'expo-router'
import { type FC } from 'react'
import { graphql, usePreloadedQuery } from 'react-relay'

import { type PhotoScreenQuery } from '@/__generated__/PhotoScreenQuery.graphql'
import { RelayPreloadedQueryByName } from '@/lib'

import { PhotoView, type PhotoViewProps } from './PhotoView'

export interface PhotoScreenProps extends Omit<PhotoViewProps, 'queryRef' | 'photoRef'> {
  queryRef: RelayPreloadedQueryByName<'PhotoScreenQuery'>
}

export const PhotoScreen: FC<PhotoScreenProps> = ({ queryRef, ...props }) => {
  const queryData = usePreloadedQuery<PhotoScreenQuery>(
    graphql`
      query PhotoScreenQuery($photoId: UUID!) {
        photo(rowId: $photoId) {
          rowId
          ...PhotoView_photo
        }
        ...PhotoView_query
      }
    `,
    queryRef
  )

  if (!queryData?.photo?.rowId) {
    return <Redirect href='/' />
  }

  return (
    <PhotoView
      photoRef={queryData?.photo}
      queryRef={queryData}
      {...props}
    />
  )
}
